import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
// ALERT_SOUND_DISABLED:
// import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
// import { applyNotificationSoundConsent } from '../utils/notificationSound';

/** In-app consent before Notification.requestPermission(). */
const NotificationAlertsConsentDialog = ({ open, onCancel, onConfirm, isSubmitting = false }) => {
  // ALERT_SOUND_DISABLED — const [soundEnabled, setSoundEnabled] = useState(true);
  // ALERT_SOUND_DISABLED — useEffect(() => { if (open) setSoundEnabled(true); }, [open]);

  const handleConfirm = () => {
    // ALERT_SOUND_DISABLED — applyNotificationSoundConsent({ soundEnabled });
    // ALERT_SOUND_DISABLED — onConfirm({ soundEnabled });
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.25, pb: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <NotificationsActiveIcon />
        </Box>
        <Box>
          <Typography variant="h6" component="span" sx={{ fontWeight: 700, display: 'block' }}>
            Enable notifications
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Your browser will ask for notification permission when you click Continue.
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Stack spacing={2}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 1.5,
              bgcolor: 'action.hover',
            }}
          >
            <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
              <strong>Notifications</strong> — event and community updates when this tab is in the
              background or minimized.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button onClick={onCancel} disabled={isSubmitting} sx={{ textTransform: 'none' }}>
          Not now
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={isSubmitting}
          autoFocus
          sx={{ textTransform: 'none', fontWeight: 600, minWidth: 120 }}
        >
          {isSubmitting ? 'Connecting…' : 'Continue'}
        </Button>
      </DialogActions>
      {/*
        ALERT_SOUND_DISABLED — alert chime consent UI (also restore useState/useEffect imports above):

        <Box sx={{ p: 1.5, borderRadius: 1.5, bgcolor: 'action.hover', display: 'flex', gap: 1.25 }}>
          <VolumeUpOutlinedIcon sx={{ mt: 0.25, color: 'primary.main' }} />
          <Typography variant="body2">
            <strong>Alert chime</strong> — a short sound while this tab is open.
          </Typography>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={soundEnabled}
              onChange={(e) => setSoundEnabled(e.target.checked)}
              color="primary"
            />
          }
          label="Play alert sounds for new notifications"
        />
      */}
    </Dialog>
  );
};

export default NotificationAlertsConsentDialog;
